import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MenuHomeEnum } from 'app/components/home';
import { MenuPermissionConfig, MenuPermissionActionEnum } from 'app/models';
import { AppComponent } from 'app/app.component';

export enum PartnerOrdersMenuEnum {
    Orders = 1,
    Feedback = 2
}

@Component({
    selector: 'partner-orders-root',
    templateUrl: './partner-orders-root.component.html',
    styleUrls: ['./partner-orders-root.component.scss'],
    providers: [MessageService]
})
export class PartnerOrdersRootComponent {
    public menuEnum = MenuHomeEnum;
    public activeMenu: MenuHomeEnum = MenuHomeEnum.PartnerDashboard;

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) { }

    public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
    }
}
